import React, { useEffect, useState } from "react";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import {
    addEvent,
    deleteEvent,
    getEventPayOff,
    getEvents,
    updateEvent,
} from "../../services/eventServices";
import moment from "moment/moment";
import { getEventPlaces } from "../../services/eventPlaceServices";
import { LinkRoute } from "../../components/LinkRoute";
import { getEventPersonnels, updateEventSupplierPersonnel } from "../../services/eventPersonnelServices";
import {
    getSpecialSalaries,
    addSpecialSalary,
    updateSpecialSalary,
    deleteSpecialSalary,
} from "../../services/eventPersonnelSpecialSalaryServices";

export const PayoffList = () => {
    const [eventList, setEventList] = useState([]);
    const [open, setOpen] = useState(false);
    const [activeEvent, setActiveEvent] = useState(null);
    const [activeSupplier, setActiveSupplier] = useState(null);
    const [supplierOpen, setSupplierOpen] = useState(false);
    const [eventPersonnelList, setEventPersonnelList] = useState([]);
    const [specialSalaryOpen, setSpecialSalaryOpen] = useState(false);
    const [specialSalaryList, setSpecialSalaryList] = useState([]);
    const [specialSalaryForm, setSpecialSalaryForm] = useState({ fullName: "", identityNumber: "", salary: "", uniqueKey: "" });
    const [salaryEdits, setSalaryEdits] = useState({});
    const [loading, setLoading] = useState(false);

    const openPayoff = (uniqueKey) => {
        setLoading(true);
        getEventPayOff(uniqueKey).then((result) => {
            setActiveEvent(result);
            setOpen(true);
        }).finally(() => setLoading(false));
    };

    const openSpecialSalaries = () => {
        getSpecialSalaries().then((result) => {
            setSpecialSalaryList(Array.isArray(result) ? result : (result.items || []));
            setSpecialSalaryOpen(true);
        });
    };

    const saveSpecialSalary = () => {
        if (!specialSalaryForm.fullName || !specialSalaryForm.identityNumber || !specialSalaryForm.salary) {
            notification.warning({ message: "Tüm alanları doldurunuz." });
            return;
        }
        const values = { ...specialSalaryForm, salary: parseFloat(specialSalaryForm.salary) };
        if (values.uniqueKey) {
            updateSpecialSalary(values).then(() => {
                notification.success({ message: "Güncelleme Başarılı" });
                setSpecialSalaryForm({ fullName: "", identityNumber: "", salary: "", uniqueKey: "" });
                getSpecialSalaries().then((res) => setSpecialSalaryList(Array.isArray(res) ? res : (res.items || [])));
            });
        } else {
            addSpecialSalary(values).then(() => {
                notification.success({ message: "Ekleme Başarılı" });
                setSpecialSalaryForm({ fullName: "", identityNumber: "", salary: "", uniqueKey: "" });
                getSpecialSalaries().then((res) => setSpecialSalaryList(Array.isArray(res) ? res : (res.items || [])));
            });
        }
    };

    const editSpecialSalary = (record) => {
        setSpecialSalaryForm({ fullName: record.fullName, identityNumber: record.identityNumber, salary: record.salary, uniqueKey: record.uniqueKey });
    };

    const deleteSpecialSalaryHandler = (uniqueKey) => {
        deleteSpecialSalary(uniqueKey).then(() => {
            notification.success({ message: "Silme Başarılı" });
            getSpecialSalaries().then((res) => setSpecialSalaryList(Array.isArray(res) ? res : (res.items || [])));
        });
    };

    const getData = () => {
        getEvents()
            .then((result) => {
                setEventList(result.items);
            })
            .catch(() => { });
    };

    const openPersonnelDetail = (supplierUniqueKey, supplierName) => {
        setLoading(true);
        getEventPersonnels(activeEvent.uniqueKey, false, null, null, supplierUniqueKey).then((result) => {
            const newList = result.items.filter(w => w.isAttended);
            setEventPersonnelList(newList);
            setActiveSupplier({ supplierUniqueKey, supplierName });
            const edits = {};
            newList.forEach(item => {
                edits[item.uniqueKey] = item.specialSalary > 0 ? item.specialSalary : item.additionalSalary + (item.personnelType == 1 ? activeEvent.chiefSalary : activeEvent.oggSalary);
            });
            setSalaryEdits(edits);
            setSupplierOpen(true);
        }).finally(() => setLoading(false));
    };

    const excelExportPersonnelList = () => {
        getEventPersonnels(activeEvent.uniqueKey, false, "excel", "payoff", activeSupplier.supplierUniqueKey).then((result) => {
            const url = window.URL.createObjectURL(new Blob([result]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Etkinlik Personel Listesi.xlsx");
            document.body.appendChild(link);
            link.click();
        });
    };

    const excelExportPersonnelListAll = () => {
        getEventPersonnels(activeEvent.uniqueKey, false, "excel", "payoff").then((result) => {
            const url = window.URL.createObjectURL(new Blob([result]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Etkinlik Personel Listesi.xlsx");
            document.body.appendChild(link);
            link.click();
        });
    };

    const saveSalary = (record) => {
        const salaryValue = salaryEdits[record.uniqueKey];
        const baseSalary = record.personnelType == 1 ? activeEvent.chiefSalary : activeEvent.oggSalary;
        const additionalSalary = salaryValue - baseSalary;
        const values = {
            uniqueKey: record.uniqueKey,
            salary: baseSalary,
            additionalSalary: additionalSalary,
        };
        updateEventSupplierPersonnel(values).then((result) => {
            notification.success({ message: "İşlem Başarılı" });
            record.additionalSalary = parseFloat(additionalSalary);
            setEventPersonnelList([...eventPersonnelList]);
        });
    };

    useEffect(() => {
        getData();
    }, []);

    const totalSupplierChief = activeEvent?.suppliers?.reduce((items, a) => items + a.addedChiefCount, 0) || 0;
    const totalSupplierOgg = activeEvent?.suppliers?.reduce((items, a) => items + a.addedOGGCount, 0) || 0;
    const totalSupplierChiefSalary = activeEvent?.suppliers?.reduce((items, a) => items + a.chiefSalary, 0) || 0;
    const totalSupplierOggSalary = activeEvent?.suppliers?.reduce((items, a) => items + a.oggSalary, 0) || 0;
    const totalSupplierAdditional = activeEvent?.suppliers?.reduce((items, a) => items + a.additionalSalary, 0) || 0;
    const totalSupplierGrandTotal = activeEvent?.suppliers?.reduce((items, a) => items + (a.oggSalary + a.chiefSalary + a.additionalSalary), 0) || 0;

    const personnelTotal = eventPersonnelList.reduce((items, a) => items + (a.specialSalary > 0 ? a.specialSalary : (a.personnelType == 1 ? activeEvent?.chiefSalary : activeEvent?.oggSalary) + (parseFloat(a.additionalSalary))), 0);

    return (
        <>
            <div className="max-w-7xl mx-auto px-4 py-6">
                <div className="flex items-center gap-3 mb-4">
                    <h1 className="text-2xl font-bold text-gray-800">Ödeme - Etkinlik Listesi</h1>
                    <button onClick={openSpecialSalaries} className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 text-sm font-medium">
                        Farklı Ücretler
                    </button>
                </div>
                <div className="bg-white rounded-lg shadow overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                            <thead className="bg-gray-50 dark:bg-gray-800">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Etkinlik Adı</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Etkinlik Tarihi</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Personel Sayısı</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Mekan</th>
                                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">İşlem</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700">
                                {eventList.map((record) => (
                                    <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:bg-gray-800">
                                        <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100 font-medium">{record.name}</td>
                                        <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{moment(record.startDate).format("DD.MM.YYYY")}</td>
                                        <td className="px-4 py-3 text-sm">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                                                {record.totalPersonnelCount}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.placeName}</td>
                                        <td className="px-4 py-3 text-sm text-right">
                                            <button
                                                onClick={() => openPayoff(record.uniqueKey)}
                                                className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 text-sm font-medium ml-auto"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                                Ödemeler
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {specialSalaryOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={() => { setSpecialSalaryOpen(false); setSpecialSalaryForm({ fullName: "", identityNumber: "", salary: "", uniqueKey: "" }); }}>
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-[800px] mx-4 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-between px-6 py-4 border-b">
                            <h2 className="text-lg font-semibold text-gray-800">Farklı Ücretler</h2>
                            <button onClick={() => { setSpecialSalaryOpen(false); setSpecialSalaryForm({ fullName: "", identityNumber: "", salary: "", uniqueKey: "" }); }} className="text-gray-400 hover:text-gray-600">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                            </button>
                        </div>
                        <div className="px-6 py-4 overflow-y-auto flex-1">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Ad Soyad</label>
                                    <input
                                        type="text"
                                        value={specialSalaryForm.fullName}
                                        onChange={(e) => setSpecialSalaryForm(prev => ({ ...prev, fullName: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">TC Kimlik</label>
                                    <input
                                        type="text"
                                        value={specialSalaryForm.identityNumber}
                                        onChange={(e) => setSpecialSalaryForm(prev => ({ ...prev, identityNumber: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Ücret</label>
                                    <input
                                        type="number"
                                        value={specialSalaryForm.salary}
                                        onChange={(e) => setSpecialSalaryForm(prev => ({ ...prev, salary: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">&nbsp;</label>
                                    <button
                                        onClick={saveSpecialSalary}
                                        className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
                                    >
                                        Kaydet
                                    </button>
                                </div>
                            </div>

                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                    <thead className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Ad Soyad</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">TC Kimlik</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Ücret</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700">
                                        {specialSalaryList.map((record) => (
                                            <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:bg-gray-800">
                                                <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.fullName}</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.identityNumber}</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 dark:text-gray-100">{record.salary}</td>
                                                <td className="px-4 py-3 text-sm">
                                                    <div className="flex gap-2">
                                                        <button onClick={() => editSpecialSalary(record)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:bg-gray-800">
                                                            Düzenle
                                                        </button>
                                                        <ConfirmButton onConfirm={() => deleteSpecialSalaryHandler(record.uniqueKey)} message="Silmek istediğinize emin misiniz?">
                                                            <button
                                                                className="px-3 py-1.5 border border-red-300 rounded-lg text-sm text-red-600 hover:bg-red-50"
                                                            >
                                                                Sil
                                                            </button>
                                                        </ConfirmButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {open && activeEvent && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={() => setOpen(false)}>
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-[1100px] mx-4 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-between px-6 py-4 border-b">
                            <h2 className="text-lg font-semibold text-gray-800">{activeEvent.name} - {moment(activeEvent.startDate).format("DD.MM.YYYY")}</h2>
                            <div className="flex items-center gap-3">
                                <button onClick={excelExportPersonnelListAll} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 text-sm font-medium border border-green-200 shadow-sm">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                                    Tüm Liste Excel'e Aktar
                                </button>
                                <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-600">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                </button>
                            </div>
                        </div>
                        <div className="px-6 py-4 overflow-y-auto flex-1">
                            <div className="overflow-x-auto" style={{ maxHeight: 500 }}>
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                    <thead className="bg-gray-50 dark:bg-gray-800 sticky top-0">
                                        <tr>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Tedarikçi</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">IBAN</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Amir</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">ÖGG</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Amir TL</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">ÖGG TL</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">EK Ödeme</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Toplam</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700">
                                        {(!activeEvent.suppliers || activeEvent.suppliers.length === 0) ? (
                                            <tr><td colSpan="8" className="px-3 py-6 text-center text-gray-500 dark:text-gray-400">Etkinlikte görevli tedarikçi bulunamadı.</td></tr>
                                        ) : activeEvent.suppliers.map((record, idx) => (
                                            <tr key={idx} className="hover:bg-gray-50 dark:bg-gray-800">
                                                <td className="px-3 py-2 text-sm">
                                                    <button
                                                        onClick={() => openPersonnelDetail(record.supplierUniqueKey, record.supplierName)}
                                                        className="text-blue-600 hover:text-blue-800 underline text-left"
                                                    >
                                                        {record.supplierName}
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.supplierIBAN}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.addedChiefCount}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.addedOGGCount}</td>
                                                <td className="px-3 py-2 text-sm">
                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">{record.chiefSalary} TL</span>
                                                </td>
                                                <td className="px-3 py-2 text-sm">
                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">{record.oggSalary} TL</span>
                                                </td>
                                                <td className="px-3 py-2 text-sm">
                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">{record.additionalSalary} TL</span>
                                                </td>
                                                <td className="px-3 py-2 text-sm">
                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700">{record.chiefSalary + record.oggSalary + record.additionalSalary} TL</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <td className="px-3 py-2"></td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">Toplam</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierChief}</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierOgg}</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierChiefSalary} TL</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierOggSalary} TL</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierAdditional} TL</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{totalSupplierGrandTotal} TL</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {supplierOpen && activeSupplier && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50" onClick={() => setSupplierOpen(false)}>
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-[1100px] mx-4 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-between px-6 py-4 border-b">
                            <h2 className="text-lg font-semibold text-gray-800">{activeSupplier.supplierName}</h2>
                            <div className="flex items-center gap-3">
                                <button onClick={excelExportPersonnelList} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 text-sm font-medium border border-green-200 shadow-sm">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                                    Tüm Liste Excel'e Aktar
                                </button>
                                <button onClick={() => setSupplierOpen(false)} className="text-gray-400 hover:text-gray-600">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                </button>
                            </div>
                        </div>
                        <div className="px-6 py-4 overflow-y-auto flex-1">
                            <div className="overflow-x-auto" style={{ maxHeight: 600 }}>
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                    <thead className="bg-gray-50 dark:bg-gray-800 sticky top-0">
                                        <tr>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Adı</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Soyadı</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">TC Kimlik</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Görevi</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">IBAN</th>
                                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Ücret</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700">
                                        {eventPersonnelList.length === 0 ? (
                                            <tr><td colSpan="6" className="px-3 py-6 text-center text-gray-500 dark:text-gray-400">Etkinlik için tedarikçinin herhangi bir akreditesi bulunmuyor.</td></tr>
                                        ) : eventPersonnelList.map((record) => (
                                            <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:bg-gray-800">
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.name}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.surname}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.identityNumber}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{(record.personnelType == 1 ? "Amir" : record.personnelType == 3 ? "Özel Güvenlik Sorumlusu" : "Özel Güvenlik") + (record.isRetired ? " (Emekli)" : "")}</td>
                                                <td className="px-3 py-2 text-sm text-gray-900 dark:text-gray-100">{record.personnelIBAN}</td>
                                                <td className="px-3 py-2 text-sm">
                                                    <div className="flex items-center gap-2">
                                                        <input
                                                            type="number"
                                                            value={salaryEdits[record.uniqueKey] || ""}
                                                            onChange={(e) => setSalaryEdits(prev => ({ ...prev, [record.uniqueKey]: e.target.value }))}
                                                            className="w-28 border border-gray-300 rounded px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                        />
                                                        <button
                                                            onClick={() => saveSalary(record)}
                                                            className="p-1.5 bg-red-600 text-white rounded hover:bg-red-700"
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"></path></svg>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <td colSpan="5" className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">Toplam</td>
                                            <td className="px-3 py-2 text-sm font-bold text-gray-900 dark:text-gray-100">{personnelTotal} TL</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
